import { initSentry } from './sentry';

initSentry();

require('./bootstrap');
require('./CapsLock');